import React, { FC, memo, useState, Fragment } from 'react'
import Link from 'next/link'

import { Button } from '@ucheba/ui/components/Button/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Heading } from '@ucheba/ui/components/Heading/desktop'

import { IInstitutionSeeAlsoProps } from '../types'

const InstitutionSeeAlso: FC<IInstitutionSeeAlsoProps> = ({ links }) => {
  const [count, setCount] = useState(10)

  return (
    <>
      <Heading h2='Смотрите также' spacing='small' />

      <Spacing spacing='small' />

      {links.slice(0, count).map((link, index) => (
        <Fragment key={link.title}>
          {index > 0 && <span>, </span>}

          <Link href={link.url}>{link.title}</Link>
        </Fragment>
      ))}

      {links.length > count && (
        <Button
          view='link'
          size='xsmall'
          onClick={() => setCount(Infinity)}
          style={{ fontWeight: 'normal' }}
        >
          {', '}
          еще...
        </Button>
      )}
    </>
  )
}

export default memo(InstitutionSeeAlso)
